import type { PlotPlaneThemeConfig } from '@/src/modules/experiences/wedding/plotPlane/plotPlaneTypes';

const BASE = '/assets/templates/royal-mandap-palace';

export const royalMandapPalaceTheme: PlotPlaneThemeConfig = {
  templateId: 'royal-mandap-palace',
  assetBase: BASE,
  palette: {
    bg: '#1a0812',
    bgDeep: '#0d0408',
    primary: '#5b1030',
    accent: '#7c3aed',
    gold: '#d4af37',
    text: '#f8efe3',
    textMuted: '#c4b5a5',
    panel: 'rgba(26, 8, 18, 0.82)',
    panelBorder: 'rgba(212, 175, 55, 0.35)',
  },
  particle: 'gold-motes',
  typography: {
    display: '"Playfair Display", "Cinzel", Georgia, serif',
    body: 'Inter, system-ui, sans-serif',
  },
  beats: [
    {
      id: 'jharokha-gate',
      navLabel: 'Jharokha gate',
      depth: 0,
      backdrop: `${BASE}/jharokha.svg`,
    },
    {
      id: 'courtyard-ganesh',
      navLabel: 'Courtyard blessing',
      depth: 520,
      backdrop: `${BASE}/courtyard.svg`,
    },
    {
      id: 'mandap-pheras',
      navLabel: 'Mandap · pheras',
      depth: 1040,
      backdrop: `${BASE}/jharokha.svg`,
    },
    {
      id: 'function-arcade',
      navLabel: 'Function arcade',
      depth: 1560,
      backdrop: `${BASE}/courtyard.svg`,
    },
    {
      id: 'rsvp-durbar',
      navLabel: 'RSVP durbar',
      depth: 2080,
      backdrop: `${BASE}/jharokha.svg`,
    },
  ],
};
